import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

const Units = () => {
    const [title, setTitle] = useState("Agregar Unidad");
    const [loading, setLoading] = useState(false);
    const [unit_id, setUnitId] = useState(0);
    const [type_unit_id, setTypeUnitId] = useState(0);
    const [partner_id, setPartnerId] = useState(0);
    const [name, setName] = useState('');
    const [units, setUnits] = useState([]);
    const [types_units, setTypesUnits] = useState([]);
    const [partners, setPartners] = useState([]);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [status_filter, setStatusFilter] = useState(2);
    const [type_filter, setTypeFilter] = useState(0);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAll();
        getTypesUnits();
        getPartners();
        setTimeout(() => {
            initializeSelect2();
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    const initializeSelect2 = () => {
        $('#type_unit_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#partner_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#status_filter').select2({ width: "100%" });
        $('#type_filter').select2({ width: "100%" });
    };

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activo', value: 1 },
        { label: 'Inactivo', value: 0 }
    ];

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#type_filter').on("change", function (e) {
        setTypeFilter(e.target.value);
    });

    $('#type_unit_id').on("change", function (e) {
        setTypeUnitId(e.target.value);
    });

    $('#partner_id').on("change", function (e) {
        setPartnerId(e.target.value);
    });

    const getTypesUnits = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-types');
        const typesUnitsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.type_unit_id,
            };
        })
        setTypesUnits(typesUnitsArray);
    };

    const getPartners = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-partners');
        const partnersArray = response.data.data.map(function (element) {
            return {
                label: element.name_partner,
                value: element.partner_id,
            };
        })
        setPartners(partnersArray);
    };

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("type_filter", type_filter);
        await axios.post(ENDPOINT + "get-all-units", form).then((response) => {
            setUnits(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por unidad",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        form.append("name", name);
        form.append("type_unit_id", type_unit_id);
        form.append("partner_id", partner_id);
        if (unit_id === 0) {
            await axios
                .post(ENDPOINT + "save-unit", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-unit/" + unit_id, {
                    name: name,
                    type_unit_id: type_unit_id,
                    partner_id: partner_id
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setUnitId(0);
        setName('');
        setTypeUnitId(0);
        setPartnerId(0);
        setTitle("Agregar Unidad");
        // Remove select2 classes and destroy instances
        $('#type_unit_id').val('0').trigger('change');
        $('#partner_id').val('0').trigger('change');
        $('#type_unit_id').select2('destroy');
        $('#partner_id').select2('destroy');
        // Reinitialize select2 after a brief delay
        setTimeout(() => {
            initializeSelect2();
        }, 100);
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-unit-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-unit/" + id)
            .then((response) => {
                setLoading(false);
                setUnitId(response.data.data.unit_id);
                setName(response.data.data.name);
                setTypeUnitId(response.data.data.type_unit_id);
                setPartnerId(response.data.data.partner_id);
                setTitle("Editar Unidad");
                $('#type_unit_id').removeClass('select2');
                $('#partner_id').removeClass('select2');
                setTimeout(() => {
                    $('#type_unit_id').addClass('select2');
                    $('#partner_id').addClass('select2');
                    initializeSelect2();
                }, 100);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-unit/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("type_filter", type_filter);
        const response = await axios.post(ENDPOINT + 'print-pdf-units', form, { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        setLoading(false);
    };

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                {title === "Agregar Unidad" ? <i className="fas fa-plus-circle me-2"></i> : <i className="fa-solid fa-pen-to-square me-2"></i>}
                                {title}
                            </h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={clearField}></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="units-form-header">
                                    <h3 className="units-form-title">Información de la Unidad</h3>
                                    <p className="units-form-subtitle">Complete los datos de la unidad para la gestión del sistema</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-form-label col-form-label-sm">
                                                Unidad <span className="units-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese unidad"
                                                id="name"
                                                name="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                            <small className="units-field-hint">Nombre de la unidad</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="type_unit_id" className="col-form-label col-form-label-sm">
                                                Tipo de unidad <span className="units-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="type_unit_id"
                                                name="type_unit_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {types_units.map((item, index) => (
                                                    <option
                                                        selected={item.value === type_unit_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="units-field-hint">Seleccione el tipo de unidad</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="partner_id" className="col-form-label col-form-label-sm">
                                                Socio <span className="units-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="partner_id"
                                                name="partner_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {partners.map((item, index) => (
                                                    <option
                                                        selected={item.value === partner_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="units-field-hint">Seleccione el socio de la unidad</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer units-form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {unit_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={clearField}>
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Unidades" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-bus-front-fill me-2"></i> Listado de Unidades
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="units-indications row mb-4">
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="units-field-hint">Estado para filtrar las unidades</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="type_filter" className="col-form-label col-form-label-sm">
                                        Tipo de Unidad
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="type_filter"
                                        name="type_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {types_units.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="units-field-hint">Tipo de unidad para filtrar</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button" >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                            <div className="col-xs-3 col-md-3">
                                <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="text-center">
                                                <td className="indications-table" width="30%" >Total</td>
                                                <td className="indications-table" width="30%" >Activos</td>
                                                <td className="indications-table" width="30%" >Inactivos</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TuserT">{active + inactive}</td>
                                                <td id="TuserA">{active}</td>
                                                <td id="TuserI">{inactive}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th width="10%" className="text-center">#</th>
                                    <th width="20%" className="text-left">Unidad</th>
                                    <th width="20%" className="text-left">Tipo de Unidad</th>
                                    <th width="10%" className="text-left">Socio</th>
                                    <th width="10%" className="text-center">Estado</th>
                                    <th width="10%" className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {units.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.unit_id}</kbd>
                                        </td>
                                        <td>
                                            {item.name}
                                        </td>
                                        <td>
                                            {item.type_unit.name}
                                        </td>
                                        <td>
                                            {item.partner.name_partner}
                                        </td>
                                        <td className="text-center">
                                            <div data-bs-toggle="tooltip" data-bs-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.unit_id)}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <span
                                                    title="Editar registro"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        className="btn-sm btn btn-warning me-1"
                                                        onClick={() => handleEdit(item.unit_id)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                <button
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Eliminar registro"
                                                    className="btn-sm btn btn-danger me-1"
                                                    onClick={() => handleDelete(item.unit_id, item.name)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Units;